// template keys

export const ID = 'id';
export const NAME = 'name';
export const SUBJECT = 'subject';
export const SMS_SUBJECT = 'sms_subject';
export const TEMPLATE_NAME = 'template_name';
export const CALL_TO_ACTION = 'static_call_to_action_url';
export const DOT = '.';
export const TEMPLATE_EXTN_HBS = 'hbs';

export const EMPTY_OBJECT = {};

export const MORTGAGE_LOAN_TEXT = 'Mortgage loan application';
export const SMALL_BUSINESS_LOAN_TEXT = 'Small business loan application';
export const BUSINESS_FUNDING_LOAN_TEXT = 'loan application';
